import { createStyles, makeStyles } from "@mui/styles"; 
import { Theme } from "@mui/material";

export const InfoDialogStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      textAlign: "justify",
      whiteSpace: "pre-line"
    },
  })
);
